@for (term of predicate.predicates; track term) {
    @if (!isCompositePredicate(term)){
    <div class="btn-group predicate-btn-group">
        <org-unit-predicate
                [orgUnits]="orgUnits"
                [predicate]="term"
                (valueChange)="doUpdateOrgUnitValue($event)"
                (remove)="doRemovePredicate($event)"
        ></org-unit-predicate>

        @if(topLevel || $index >= (predicate.predicates.length - 1)){
        <div class="btn-group combinator">
            <button class="btn btn-secondary dropdown-toggle add-btn"
                    type="button"
                    [matMenuTriggerFor]="orgUnitMenu">
                <i class="far fa-plus"></i>
            </button>
            <mat-menu #orgUnitMenu="matMenu">
                @for (orgUnitType of orgUnitTypes; track orgUnitType) {
                <span mat-menu-item (click)="doAddFilterInGroup({ orgUnitType, id: topLevel ? term.id : predicate.id })">{{ orgUnitType }}</span>
                }
            </mat-menu>
        </div>
        }
    </div>
    }

    @if (isCompositePredicate(term)){
    <composite-predicate
            [predicate]="term"
            [orgUnits]="orgUnits"
            (combinatorChange)="doUpdateCombinator($event)"
            (orgUnitValueChange)="doUpdateOrgUnitValue($event)"
            (removePredicate)="doRemovePredicate($event)"
            (orgUnitValueAdd)="doAddFilterInGroup($event)"
    ></composite-predicate>
    }
    
    @if ($index < (predicate.predicates.length - 1)) {
        <div class="btn-group predicate-btn-group combinator"
                role="group">
            <button class="btn btn-secondary dropdown-toggle add-btn"
                    type="button"
                    [ngClass]="{ 'top-combinator-btn': topLevel }"
                    [matMenuTriggerFor]="combinatorMenu">
        
                {{predicate.combinator.toUpperCase()}}
            </button>
        
            <mat-menu #combinatorMenu="matMenu">
                @for (combinator of combinators; track combinator) {
                <span mat-menu-item (click)="doUpdateCombinator({ combinator, id: predicate.id })">{{ combinator }}</span>
                }
            </mat-menu>
        </div>
    }
    
}